import React, { useState, useCallback, useRef } from 'react';
import { AutoComplete } from 'antd';
import axios from '../../utils/axios';

const PropertyKeyAutoComplete = ({ value, onChange, placeholder, style, ...rest }) => {
  const [options, setOptions] = useState([]);
  const debounceRef = useRef(null);

  const handleSearch = useCallback((searchText) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    if (!searchText || searchText.length < 1) {
      setOptions([]);
      return;
    }

    debounceRef.current = setTimeout(async () => {
      try {
        const response = await axios.get('/integrations/properties/tracked-keys', {
          params: { search: searchText, limit: 5 },
        });
        const props = response.data?.properties || [];
        setOptions(
          props.map((p) => ({
            value: p.key,
            label: (
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>{p.key}</span>
                <span style={{ color: '#999', fontSize: 12 }}>{p.label}</span>
              </div>
            ),
          }))
        );
      } catch {
        setOptions([]);
      }
    }, 250);
  }, []);

  return (
    <AutoComplete
      value={value}
      onChange={onChange}
      onSearch={handleSearch}
      options={options}
      placeholder={placeholder || 'Property key'}
      style={style}
      {...rest}
    />
  );
};

export default PropertyKeyAutoComplete;
